import { useQuery } from "@tanstack/react-query";
import { reportsService } from "../services/reports.service";
import { useAuthStore } from "../store/auth.store";

export function useAccessionLogPrefixes() {
  const userId = useAuthStore((state) => state.profile?.id);
  return useQuery({
    queryKey: ["reports", "accession-log-prefixes", userId],
    queryFn: reportsService.getAccessionLogPrefixes,
    enabled: Boolean(userId),
  });
}
